import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addSector } from "common/services/data-types.service";
import Form from "./Form";
import { toast } from "react-toastify";

const AddSector: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values["name"] ? values["name"].trim() : null,
        },
      };

      setLoading(true);
      try {
        await addSector(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Sector added successfully", {});
      } catch (e: any) {
        toast.error("Sector creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Sector
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddSector;
